import { dlTrackEvent } from "components/dataLayer/dataLayer";
import { Link } from "react-router-dom";

const SolMezclasId = () => {

  const handleClickLinking = () => {
    dlTrackEvent('user_interaction', {
      action: 'click',
      element: 'HOME :: Ver mi ID',
      section: 'HOME'
    })
  }

  return (
    <Link to={'/profile/identificacion'} onClick={handleClickLinking}>
      <img src={`${AZURE_BASE_URL}/home-solmezclas-id.webp`} className='w-full' />
    </Link>
  )
}

export default SolMezclasId